import {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbPieChart,
    mdbCard,
    mdbCardBody,
    mdbCardUp,
    mdbCardAvatar,
    mdbDoughnutChart,
    mdbBarChart,
    mdbIcon,
    mdbBtn,
    mdbTooltip,
    mdbDropdown,
    mdbDropdownItem,
    mdbDropdownMenu,
    mdbDropdownToggle,
    mdbInput,
    mdbDatePicker
} from "mdbvue";
import Datepicker from 'vuejs-datepicker';
import Popup from "../../../core/Popup";
import { es } from 'vuejs-datepicker/dist/locale'
import Btn from "../../../core/Button";
import { mapActions, mapGetters } from "vuex";
import moment from 'moment';
import Loader from "../../../core/Loader";

const Dashboard = {
    name: "Dashboard",
    components: {
        mdbContainer,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardBody,
        mdbPieChart,
        mdbCardUp,
        mdbCardAvatar,
        mdbDoughnutChart,
        mdbBarChart,
        mdbIcon,
        mdbBtn,
        mdbTooltip,
        mdbDropdown,
        mdbDropdownItem,
        mdbDropdownMenu,
        mdbDropdownToggle,
        mdbInput,
        mdbDatePicker,
        Datepicker,
        Popup,
        Btn,
        Loader
    },
    data() {
        return {
            isLoading: false,
            datePickerValue: new Date(),
            datePickerMonth: new Date(),
            filterText: {
                type: 'día',
                date: moment(new Date()).format('DD-MM-YYYY'),
            },
            languageDatePicker: es,
            pieChartData: {},
            pieChartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    position: "bottom",
                    labels: {
                        boxWidth: 14,
                        fontSize: 14,
                        fontFamily: "Open Sans",
                        fontColor: "#0b200b",
                    }
                },
                plugins: {
                    datalabels: {
                        color: "red",
                        align: "left",
                        font: {
                            size: 40
                        },
                        formatter: value => {
                            const [dataset] = this.pieChartData.datasets;
                            const setValue = dataset.data.reduce((a, b) => a + b);

                            return `${Math.round((value / setValue) * 100)}%`;
                        }
                    }
                }
            },
            limit: [{
                type: 'weekday',
                available: []
            }],
            barChartData: {},
            accepted: 0,
            researched: 0,
            created: 0,
            review: 0,
            requestTotal: 0,
            options: {
                placeholder: '2018-04-13',
                label: "default date"
            },
            barChartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    display: true,
                    position: "bottom",
                    labels: {
                        boxWidth: 14,
                        fontSize: 14,
                        fontFamily: "Open Sans",
                        fontColor: "#0b200b"
                    }
                },

                scales: {
                    xAxes: [
                        {
                            barPercentage: 1,
                            gridLines: {
                                display: true,
                                color: "rgba(0, 0, 0, 0.1)"
                            }
                        }
                    ],
                    yAxes: [
                        {
                            gridLines: {
                                display: true,
                                color: "rgba(0, 0, 0, 0.1)"
                            },
                            ticks: {
                                stepSize: 1,
                                min: 0
                            }
                        }
                    ]
                }
            }
        };
    },
    methods: {
        ...mapActions([
            "getDailyStatistics",
            "getMonthlyStatistics"
        ]),
        pushNotifyError(){
            this.$notify.error({
                message: "Ha ocurrido un error, inténtalo más tarde.",
                position: "top right",
                timeOut: 15000
            });
        },
        setDataToCharts({accepted,created, researched, review, date, type}){
            this.barChartData = {
                labels: [date],
                datasets: [
                    {
                        label: "Nuevas",
                        data: [created],
                        backgroundColor: [
                            "#386aca",
                        ],
                        borderWidth: 1
                    },
                    {
                        label: "Listas para revisión",
                        data: [researched],
                        backgroundColor: [
                            "#eeb141",
                        ],
                        borderWidth: 1
                    },
                    {
                        label: "Revisión por comité",
                        data: [review],
                        backgroundColor: [
                            "#f78c4f",
                        ],
                        borderWidth: 1
                    },
                    {
                        label: "Aceptadas",
                        data: [accepted],
                        backgroundColor: [
                            "#f7594f",
                        ],
                        borderWidth: 1
                    }
                ]
            };
            this.pieChartData = {
                labels: [
                    "Nuevas",
                    "Lista para revisión",
                    "Revisión por comité",
                    "Aceptadas"
                ],
                datasets: [
                    {
                        data: [created, researched, review, accepted],
                        backgroundColor: ["#386aca", "#eeb141", "#f78c4f", "#f7594f"],
                        hoverBackgroundColor: ["#386aca", "#eeb141", "#f78c4f", "#f7594f"]
                    }
                ]
            };
            this.requestTotal = accepted + created + researched + review;
            this.filterText = {
                type,
                date: type === 'mes' ? `de ${date}` : date
            };
        },
        async setFilterDay(isComponentMounted){
           try {
               if (this.$refs.filterDay.open) {
                   this.$refs.filterDay.toggleModal();
               }
               const date = moment(isComponentMounted ? new Date() : this.datePickerValue).format('DD-MM-YYYY');
               this.isLoading = !isComponentMounted;
               const dateFilter = await this.getDailyStatistics(date);
               this.setDataToCharts({
                   ...dateFilter.data.data,
                   date,
                   type: 'día'
               });

               // When component mounted refresh the 4 status on top
               if (isComponentMounted) {
                   const { accepted,created, researched, review } = dateFilter.data.data;
                   this.accepted = accepted;
                   this.created = created;
                   this.researched = researched;
                   this.review = review;
               }
           }
           catch (e) {
               this.pushNotifyError();
           }finally {
               this.isLoading = false;
           }
        },
        async setFilterMonth(){
            try {
                if (this.$refs.filterMonth.open) {
                    this.$refs.filterMonth.toggleModal();
                }

                const month = moment(this.datePickerMonth).format('MM');
                const montLetters = moment(this.datePickerMonth).locale('es').format('MMMM');
                const year = moment(this.datePickerMonth).format('YYYY');
                this.isLoading = true;
                const dataFilter = await this.getMonthlyStatistics({ month, year });

                this.setDataToCharts({
                    ...dataFilter.data.data,
                    date: `${montLetters} del ${year}`,
                    type: 'mes'
                });
            }
            catch (e) {
                this.pushNotifyError();
            }
            finally {
                this.isLoading = false;
            }
        },
    },
    mounted() {
        if(this.loginUserType != 'SUPER_ADMIN'){
            this.setFilterDay(true);
        }
       
    },
    computed: {
        ...mapGetters({
            loginUserType: "getUserType",
        }),

    }
};

export default Dashboard;